import { useState } from 'react';
import { IconButton, Menu, MenuItem, Link } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { useExternalLinks } from './api/getExternalLinks';
const LinkMenu = () => {
  const { data: externalLinks } = useExternalLinks({});
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!externalLinks || externalLinks.length === 0) return null;

  return (
    <div>
      <IconButton onClick={handleMenu} size='large' color='inherit'>
        <LinkIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        open={open}
        onClose={handleClose}
        style={{ zIndex: 999999 }}
      >
        {externalLinks?.map((link) => (
          <MenuItem sx={{ minWidth: '200px' }} key={link.id}>
            <Link
              target='_blank'
              rel='noopener noreferrer'
              href={link.link}
              underline='none'
            >
              {link.name}
            </Link>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LinkMenu;
